import { render, staticRenderFns } from "./ReportSetWxAuth.vue?vue&type=template&id=3fa7ea04&scoped=true"
import script from "./ReportSetWxAuth.vue?vue&type=script&lang=js"
export * from "./ReportSetWxAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa7ea04",
  null
  
)

export default component.exports